<script>
  import YT from "./YT.svelte";
  export let name;
  const src = "https://www.guitaracademy.nl/img/vaderzoon.jpg";
  const alt = "Vader Zoon";
  let color = "blue";
  let toggle = () => {
    color = color === "blue" ? "red" : "blue";
  };
  const ytIds = ["hXQxSi34GWY", "7gphiFVVtUI", "yux4zMXLcZU"];
  let cats = [
    { id: "J---aiyznGQ", name: "Keyboard Cat" },
    { id: "z_AbfPXTKms", name: "Maru" },
    { id: "OUtn3pvWmpg", name: "Henri The Existential Cat" },
  ];
  let committee = `Tommy Emmanuel
                    Harry Sacksioni
                    Ad Verbrugge (philosopher, 'beter onderwijs nederland')
                    Erik Scherder (neuropsychologist)`.split(/\n/);
  let guests = `Ad Verbrugge
                Adam Rafferty
                Andrea Valeri
                Andreas Oberg
                Antoine Boyer
                Anton Goudsmit
                Basily Boys
                Bram Stadhouders
                Chieli Minucci
                Don Ross
                Ed Verhoeff
                Eef Albers
                Emil Ernebro
                Eric Vaarzon Morel
                Five Great Guitars
                Franco Morone
                Frank Vignola
                Gareth Pearson
                Igor Presnyakov
                Jan Kuiper
                Jesse van Ruller
                Johannes Moller
                Jon Gomm
                Joscho Stephan
                Kaki King
                Marcel Singer
                Martien Oster
                Michael Fix
                Michael Lee Firkins
                Mike Dawes
                Paolo Sereno
                Paulus Schafer
                Reinier Baas
                Richard Hallebeek
                Richard Smith (Fingerstyle)
                Ruben Hoeke
                Shane Hennessy
                Sietze Bouma
                Sonke Meinen
                Stochelo Rosenberg`.split(/\n/);
</script>

<main>
  <h1 style="color: {color}; cursor: pointer" on:click={toggle}>{name}</h1>
  <p>De gitaar als verbindingsinstrument in Nederland.</p>
  <p>
    <strong>Gitaar.org</strong> is an organisation with a societal mission:
    develop new talent and improve the music scene. It has strong ties with
    established names, independent teachers, the conservatories and young
    talented guitarstudents (see Committee of Recommendation). It creates a
    music community for a better connected world. <br /><br />
    This community serves as a place to increase musical collaboration. Since 2011
    it has invited established names (see History) in an intimate setting where great
    talents could develop their own sound. This has allowed for some new influential
    artist like Eddie van der Meer with
    <a href="https://www.youtube.com/c/EddievanderMeer">2,5 million</a> followers
    on YouTube.
  </p>

  <h1>Committee of Recommendation</h1>
  <p>
    {#each committee as member}
      {member}<br />
    {/each}
  </p>

  <h1>History</h1>
  <p>
    {#each guests as guest}
      {guest}<br />
    {/each}
  </p>
  <img {src} {alt} />

  {#each ytIds as id}
    <YT {id} />
  {/each}
</main>

<style>
  main {
    text-align: center;
    padding: 1em;
    max-width: 240px;
    margin: 0 auto;
  }

  h1 {
    color: #ff3e00;
    text-transform: uppercase;
    font-size: 4em;
    font-weight: 50;
  }

  @media (min-width: 640px) {
    main {
      max-width: none;
    }
  }
</style>
